var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterController = function SvgFilterController(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M19.5 10.212H7.145m-4.361 0H1m1.784 0a2.18 2.18 0 1 1 4.36 0 2.18 2.18 0 0 1-4.36 0ZM19.5 16.819h-5.748m0 0a2.182 2.182 0 0 1-3.722 1.541 2.18 2.18 0 0 1-.639-1.541m4.361 0a2.18 2.18 0 0 0-4.361 0m0 0H1M19.5 3.605h-3.105m-4.361 0H1m11.034 0a2.18 2.18 0 1 1 4.36 0 2.18 2.18 0 0 1-4.36 0Z"
  })));
};
export { SvgFilterController as ReactComponent };
export default "/_next/static/media/static/media/filter_controller.5c003b6bf81d4a7694d26a022a0a4f8esvg";